import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  setStandardCalculationMode,
  setTransactionSideCalculationMode
} from 'bundles/apex/deals/form/store/deal/actions';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';
import { calculationModes, calculationModeOptions } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

export function DealType({
  allowTransactionSide,
  deal,
  setStandardCalculationMode,
  setTransactionSideCalculationMode
}) {
  if (deal.id || !allowTransactionSide) {
    return null;
  }

  const [mode, setMode] = useState(calculationModes.standard);
  const handleModeChange = (value) => {
    if (value === calculationModes.transactionSide) {
      setTransactionSideCalculationMode();
    } else {
      setStandardCalculationMode();
    }
    setMode(value);
  };

  return (
    <ManagedFormGroup
      includeBlank
      label="Calculation Mode"
      required
      type="select"
      value={mode}
      onValueChange={handleModeChange}
    >
      <Options options={calculationModeOptions} />
    </ManagedFormGroup>
  );
}

DealType.propTypes = {
  allowTransactionSide: PropTypes.bool,
  deal: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  setStandardCalculationMode: PropTypes.func.isRequired,
  setTransactionSideCalculationMode: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  allowTransactionSide: state.features.transactionSideDetails,
  deal: state.deal,
});

const mapDispatchToProps = {
  setStandardCalculationMode,
  setTransactionSideCalculationMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealType);
